const learningDetails = [
  {
    id: "1",
    title: "node-js",
    imgPath: "node.jpeg",
    description:
      "Node.js is a JavaScript runtime built on Chrome's V8 JavaScript engine. It's used for building fast and scalable server-side applications.",
    ghLink: "https://github.com/nitin7213/node-js.git",
    lastUpdated: "19-06-2024",
  },
  {
    id: "2",
    title: "react-js",
    imgPath: "react.png",
    description:
      "React.js is a JavaScript library for building user interfaces, primarily for single-page applications. It allows developers to create large web applications that can update and render efficiently in response to data changes.",
    ghLink: "https://github.com/nitin7213/react-js.git",
    lastUpdated: "12-06-2024",
  },
];

export default learningDetails;
